export class FiltroTipoReporte {
    id : number;
    tipo : string;
    filtros : Filtro;
}
export class Filtro { // se agregarán todos los filtros de TODOS los reportes de ese componente
    idConductor? : boolean;
    tipoAsistencia? : boolean;
    fechaInicio? : boolean;
    fechaFin? : boolean;
    idServicio? : boolean;
    nombreCliente? : boolean;
    nombreConductor? : boolean;
    idTiendaCliente? :  boolean;
    idMotivoCancelacion?:  boolean;
    Estrellas?:  boolean;
    
}
export class FiltroAsistencia {
    idConductor : string;
    tipoAsistencia : number;
    fechaInicial : string;
    fechaFinal : string;
    tipoJornada:number
    page:number
    rows:number
}
// export class ComentarioCliente{
//    fechaInicio : boolean;
//    fechaFin : boolean;
   
// }

export class FiltroCliente {
    rows:             number;
    page:             number;
    idConductor:      string;
    nombre:  string;
    fechaInicial:  string;
    FechaFinal:   string;
    estrellas:    number;
    idServicio:   number;
    fechaFinal:string;
    idCliente : number;
}

export class FiltroConductor {
    rows:             number;
    page:             number;
    idConductor:      string;
    nombre:  string;
    fechaInicial:     string;
    FechaFinal:       string;
    estrellas:        number;
    idServicio:       number;
}
export class FiltroFormularioConductor {
  page: number;
  rows: number
  paginacion : PaginacionReporte;
  fechaInicio:         string;
  fechaFin:            string;
  idConductor:         string;
  idTiendaCliente:     number;
  idMotivoCancelacion: number;
}
export class PaginacionReporte {
    rows:             number;
    page:             number;
}
